import { win } from '@wix/cashier-common/dist/src/utils/win';
import { type OutboundEventName } from '../../types/OutboundEventName';
import { type EventMessage } from './types';

export const sendEventMessage = (event: OutboundEventName, payload: any, targetOrigin: string): void => {
  win.parent.postMessage(
    {
      event,
      ...(payload !== undefined && { payload }),
    } as EventMessage,
    targetOrigin,
  );
};
